import React, { Component } from 'react';
import AuthService from '../services/auth';
import './profile.css';
import SettingsMenu from '../components/SettingsMenu';
import SettingsIndex from '../components/SettingsIndex';
import SettingsEmail from '../components/SettingsEmail';
import SettingsPassword from '../components/SettingsPassword';
import SettingsDelete from '../components/SettingsDelete';
import SettingsPayments from '../components/SettingsPayments';
import SettingsMagnets from '../components/SettingsMagnets';
import SettingsPasses from '../components/SettingsPasses';
import SettingsPromoCode from '../components/SettingsPromoCode';
import Api from '../services/api';

class Settings extends Component {

  constructor(props) {
    super(props);

    this.state = {
      active: this.props.match.params.type,
      paymentStatus: this.props.match.params.paymentStatus,
      user: {},
    }
  }

  componentDidMount() {
    if(!AuthService.isLoggedIn()) {
      window.location = '/join';
    }else {
      (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
        .then(response => {
          this.setState({
            user: response.user,
          });
        });
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      active: newProps.match.params.type,
    });
  }

  render() {
    const { user } = this.state;
    return (
      <div className="container profile">
        {AuthService.isLoggedIn() &&
        <div className="row">
          <SettingsMenu active={this.state.active} current={user}/>
          {(typeof this.state.active === "undefined") && <SettingsIndex title="Change Settings"/>  }
          {this.state.active === 'password' && <SettingsPassword title="SETTINGS > EDIT PASSWORD"/>}
          {this.state.active === 'email' && <SettingsEmail title="SETTINGS > EDIT EMAIL ADDRESS"/>}
          {this.state.active === 'delete-account' && <SettingsDelete title="SETTINGS > ACCOUNT REMOVAL"/>}
          {this.state.active === 'payments' && <SettingsPayments title="SETTINGS > PAYMENTS"/>}
          {this.state.active === 'magnets' && <SettingsMagnets title="SETTINGS > MAGNETS"/>}
          {this.state.active === 'superior-passes' && <SettingsPasses title="SETTINGS > SUPERIOR PASSES"/>}
          {this.state.active === 'promo-code' && <SettingsPromoCode title="PERSONAL PROMOCODE"/>}
        </div>}
      </div>
    );
  }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/pages/settings.js